/*
 * Copyright (c) 2022 Virginia Tech Transportation Institute.  All rights reserved.
 */

import Button from '@material-ui/core/Button'
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import React, { useCallback } from 'react'
import { useLocation } from '../../common/util/reactRouterHooks'

type ScenarioButtonProps = {
  id: string;
  name: string;
  style?: CSSProperties;
}

const ScenarioButton = (props: ScenarioButtonProps): JSX.Element => {
  const { id, name, style = {} } = props

  const { navigate } = useLocation()
  const handleLaunch = useCallback(() => navigate(`functionalscenario/${id}`), [id, navigate])

  return (
    <Button onClick={handleLaunch} style={style} variant="outlined" color="primary">
      <Typography variant="h6" style={{ textTransform: "none" }}>{name}</Typography>
    </Button>
  )
}

export default ScenarioButton
